import React, { JSX, useEffect, useState } from "react";

const Maintenance = (): JSX.Element => {
  const [header, setHeader] = useState("")
  const [message, setMessage] = useState("")

  useEffect(() => {
    setHeader(window.environment?.maintenanceHeader ?? "Tour Report Order Form under maintenance")
    setMessage(window.environment?.maintenanceMessage ?? "The service you're looking for is unavailable at the moment. We'll be back up and running again soon. Thanks for your patience!")
  }, []);

  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "12px" }}>{header}</h1>
      <h3 style={{ textAlign: "center", marginTop: "12px", maxWidth: "600px", margin: "auto auto" }}>{message}</h3>
    </div>
  );
};

export default Maintenance;
